module.exports = __webpack_public_path__ + "static/img/icon_visit_tab_content.368e9e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_visit_tab_content.png
// module id = f6GE
// module chunks = 1